import Axios from "axios";
// import app from "@/store/app";
import { apiUrl } from "../config";

const instance = Axios.create({
  baseURL: apiUrl + "/",
});

instance.interceptors.request.use(
  function (config) {
    // app.setFetching(true);
    return config;
  },
  function (error) {
    // app.setFetching(false);
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  function (response) {
    // app.setFetching(false);

    if (response?.data?.status !== "ok") {
      return Promise.reject(response?.data?.message || "Error!");
    }
    return response?.data?.data;
  },
  function (error) {
    if (error.response?.status === 404) {
      window.location.href = "/404";
    } else if (error.response?.status === 429) {
      // app.setFetching(true, "429");
    }
    return Promise.reject(error);
  },
);

const ServerAPI = {
  async getMainPage() {
    return instance.get("/");
  },
  // async getHotelPage(id, country = "", region = "", city = "") {
  //   return instance.post("hotel/" + id, {
  //     country,
  //     region,
  //     city,
  //     datein: app.dateCheckin,
  //     dateout: app.dateCheckout,
  //     guests: app.guestsCount,
  //     child: app.guestsChildren,
  //   });
  // },
  async selectCity(country = "", region = "") {
    return instance.get(`find/${country}/${region}`);
  },
  // async findHotels(
  //   country = "",
  //   region = "",
  //   city = "",
  //   place = "",
  //   query = "",
  // ) {
  //   return instance.post(
  //     `find/${country}/${region}/${city || "all"}?${query}`,
  //     {
  //       datein: app.dateCheckin,
  //       dateout: app.dateCheckout,
  //       guests: app.guestsCount,
  //       child: app.guestsChildren,
  //       place: place,
  //     },
  //   );
  // },
  async customPostQuery(url, args = {}) {
    return instance.post(url, args);
  },
  async customGetQuery(url) {
    return instance.get(url);
  },
};

export default ServerAPI;
